// import { useContract, useAccount, useProvider, useSigner } from "wagmi";
import {
  writeContract,
  readContract,
  prepareTransactionRequest,
  waitForTransactionReceipt,
} from "wagmi/actions";
import { ethers } from "ethers";
import ICOContract from "./ISOContract.json";
import stakeContract from "./stakContract.json";
import { config } from "../Provider/config";
import zeussToken from "./zeussToken.json";
import { toast } from "react-toastify";


export const addTokenToWallet = async (walletClient) => {
  try {
     // Get wallet client

    if (!walletClient) {
      console.error("Wallet client not found. Make sure MetaMask is connected.");
      return;
    }

    const wasAdded = await walletClient.request({
      method: "wallet_watchAsset",
      params: {
        type: "ERC20",
        options: {
          address: zeussToken.address,  // Token contract address
          symbol: zeussToken.symbol,    // Token symbol (e.g., USDT)
          decimals: zeussToken.decimal, // Token decimals (e.g., 18)
          image: "", // Optional token image URL
        },
      },
    });

    if (wasAdded) {
      toast.success(`${zeussToken.symbol} was successfully added to the wallet!`);
    } else {
      toast.error(`${zeussToken.symbol} was not added.`);
    }
  } catch (error) {
    console.error("Error adding token:", error);
  }
};


export const formatBalance = (amount, decimal, format) => {
  try {
    const formatted = ethers.formatUnits(amount, decimal);
    return parseFloat(formatted).toFixed(format);
  } catch (error) {
    return "0.00";
  }
};
export const parsBalance = (amount, decimal) => {
  try {
    return ethers.parseUnits(amount, decimal);
  } catch (error) {
    return "0.00";
  }
};

export const formatNumber = (num) => {
  if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(1).replace(/\.0$/, "") + "k";
  } else {
    return num.toString();
  }
};

// Get User Balances
export const getUserBalances = async (user, tokenAddress, abi) => {
  try {
    const balance = await readContract(config, {
      address: tokenAddress,
      abi: abi,
      functionName: "balanceOf",
      args: [user],
    });

    return balance;
  } catch (error) {
    console.error("Error fetching balances:", error);
    return null;
  }
};

// Calculate Token Amount
export const calculateToken = async (amount) => {
  try {
    const result = await readContract(config, {
      address: ICOContract.address,
      abi: ICOContract.abi,
      functionName: "calculateToken",
      args: [amount],
    });

    return result[0];
  } catch (error) {
    console.error("Error calculateToken:", error);
    return null;
  }
};

// Get Sale Info
export const getSaleInfo = async () => {
  try {
    const result = await readContract(config, {
      address: ICOContract.address,
      abi: ICOContract.abi,
      functionName: "getSaleInfo",
    });

    return result;
  } catch (error) {
    console.error("Error getSaleInfo:", error);
    return null;
  }
};

// Buy Tokens
export const buy = async (amount, token) => {
  try {
    const result = await writeContract({
      address: ICOContract.address,
      abi: ICOContract.abi,
      functionName: "buy",
      args: [amount, token],
    });

    return result;
  } catch (error) {
    console.error("Error buy:", error);
    return null;
  }
};

// Get User Stakes
export const getUserStakes = async (user) => {
  try {
    const result = await readContract(config, {
      address: stakeContract.address,
      abi: stakeContract.abi,
      functionName: "getUserStakes",
      args: [user],
    });

    return result;
  } catch (error) {
    console.error("Error getUserStakes:", error);
    return null;
  }
};

// Stake Tokens
export const stake = async (amount, time) => {
  try {
    const config = await prepareTransactionRequest({
      address: stakeContract.address,
      abi: stakeContract.abi,
      functionName: "stake",
      args: [amount, time],
    });

    const result = await writeContract(config);
    return result;
  } catch (error) {
    console.error("Error stake:", error);
    return null;
  }
};

// Withdraw Tokens
export const withdraw = async (amount, token) => {
  try {
    const config = await prepareTransactionRequest({
      address: ICOContract.address,
      abi: ICOContract.abi,
      functionName: "withdraw",
      args: [amount, token],
    });

    const result = await writeContract(config);
    return result;
  } catch (error) {
    console.error("Error withdraw:", error);
    return null;
  }
};

// Call Contract Function (Generalized)
export const callReadContract = async (
  contractAddress,
  abi,
  functionName,
  args = []
) => {
  try {
    const result = await readContract(config, {
      address: contractAddress,
      abi: abi,
      functionName: functionName,
      args: args,
    });

    return result;
  } catch (error) {
    console.error(`Error in ${functionName}:`, error);
    return null;
  }
};
export const callWriteContract = async (
  contractAddress,
  abi,
  functionName,
  args = []
) => {
  try {
    const result = await writeContract(config, {
      address: contractAddress,
      abi: abi,
      functionName: functionName,
      args: args,
    });

    return result;
  } catch (error) {
    console.error(`Error in ${functionName}:`, error);
    return null;
  }
};

export const getTxn = async (hash) => {
  try {
    if (!hash) {
      return null;
    }
    const transactionReceipt = await waitForTransactionReceipt(config, {
      hash,
    });

    return transactionReceipt.status === "success" ? true : false;
  } catch (error) {
    console.error("Error getTxn:", error);
    return null;
  }
};
